import Vue from "vue";
import {api as configs} from "@/app/config";
import {getData} from "@/app/plugins/utils";

export const getEquipamentos = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'equipment'+payload).then(getData)
}

export const getExportAjusteFinanceiro = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'export/payment_adjust'+payload).then(getData)
}

export const getExportEquipamentos = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'export/equipment'+payload).then(getData)
}

export const exportECs = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'export/department_store'+payload).then(getData)
}

export const getExportTransaction = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'export/transaction'+payload).then(getData)
}

export const getExportTransactionV3 = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'v3/export/transaction'+payload).then(getData)
}

export const getExportTransactionBacen = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'export_bacen/transaction'+payload).then(getData)
}

export const getExportTransactionBacenV3 = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'v3/export_bacen/transaction'+payload).then(getData)
}

export const getMCC = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'mcc'+payload).then(getData)
}

export const getEstaComercial = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'department_store'+payload).then(getData)
}

export const getExportClientes = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'export/department_store/clients_per_plan'+payload).then(getData)
}

export const getExportReceivables = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'export/receivables'+payload).then(getData)
}

export const getExportMarketplaceReceivables = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'export/marketplace_receivable'+payload).then(getData)
}

export const getExportReceivablesV3 = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'v3/export/receivables'+payload).then(getData)
}

export const getExportConciliationStone = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'export/conciliationStone'+payload).then(getData)
}

export const getExportConciliationStoneV3 = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'v3/export/conciliationStone'+payload).then(getData)
}

export const exportAnalysisRisk = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'risk_analysis/export'+payload).then(getData)
}

export const getOnboardingList = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'onboarding'+payload).then(getData)
}

export const getOnboardingReport = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'onboarding/export'+payload).then(getData)
}

export const getIntegrationMerchant = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'department_store/integration_report'+payload).then(getData)
}
export const getIntegrationReseller = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'marketplace/integration_report'+payload).then(getData)
}

export const getActivationList = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'activation'+payload).then(getData)
}

export const getActivationReport = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'activation/export'+payload).then(getData)
}
